import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EventMedia from './index';
import { ModalLoadingPage } from 'APP_ROOT/components/common/loadingPage';
import { strings } from 'APP_ROOT/localization';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
export default class EventClusterMediaCarousel extends PureComponent {

    static propTypes = {
        events: PropTypes.array.isRequired,
        onSelectEvent: PropTypes.func.isRequired,
        selectedEvent: PropTypes.object.isRequired,
        // required by EventMedia
        selectedRavenUuid: PropTypes.string.isRequired,
        //selectedEventId: PropTypes.string.isRequired,
        mqttService: PropTypes.object.isRequired,
        features: PropTypes.object.isRequired,
        mediaRequestType: PropTypes.string.isRequired,
        unplugged: PropTypes.bool,
        offline: PropTypes.bool,
        onLiveStream: PropTypes.func.isRequired
    }

    componentDidMount() {
        //this.goToSlide(this.props.selectedEvent.clusterOffsetIndex);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.selectedEvent.clusterOffsetIndex !== this.props.selectedEvent.clusterOffsetIndex) {
            //this.goToSlide(this.props.selectedEvent.clusterOffsetIndex);
        }
    }
    render () {
        const clusterEvents = this.props.events;
        const carouselElements = clusterEvents.map((clusterEvent) => {
            const shouldAutoPlay = this.props.selectedEvent === clusterEvent;
            return <EventMedia
                key={clusterEvent.clusterOffsetIndex}
                clusterItemIndex={clusterEvent.clusterOffsetIndex}
                selectedRavenUuid={this.props.selectedRavenUuid}
                selectedEventId={clusterEvent.eventId}
                mqttService={this.props.mqttService}
                features={this.props.features}
                mediaRequestType={this.props.mediaRequestType}
                onLiveStream={this.props.onLiveStream}
                offline={this.props.offline}
                autoPlay={shouldAutoPlay}
            />
        });

        return (
            <div className="cluster-media-component">
                <Carousel
                    selectedItem={this.props.selectedEvent.clusterOffsetIndex}
                    onChange={(currentIndex, currentSlide) => {
                        this.props.onSelectEvent(clusterEvents[currentIndex]);
                    }}
                    showThumbs={false} // thumbs along the bottom of the carousel
                    showStatus={false} // status is "1 of 2" messages, may be difficult to localize
                    showIndicators={false} // dots along the bottom of the carousel
                    infiniteLoop={false} // when looping, it scrolls back so it looks like the forward arrow triggers backward when just two items
                    //axis={"vertical"}
                >
                    {carouselElements.map((carouselElement) => {return carouselElement;})}
                </Carousel>
            </div>
        )
    }
}